import "../css/CommonDesign.css";
import { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import parse from 'html-react-parser';
import { TextField, Container, Stack, Button, Breadcrumbs, Typography, Link } from "@mui/material";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import axios from "axios";
import { API } from "./constantsFront";
import MenuMenu from "./MenuMenu";

/**
 * よくあるご質問（詳細）
 * @returns 
 */
function D00502QuestionDetail() {

  const navigate = useNavigate();
  const location = useLocation();

  location.state = location.state == null ? { "question": -1 } : location.state; //2023/04/26:プレビュー表示のために追加
  const preview = localStorage.getItem("preview")                             //2023/04/26:プレビュー表示用データを取得
  let previewdata = JSON.parse(preview);
  localStorage.removeItem("preview");                                         //プレビュー用に保存したデータを削除

  const [questionDetail, setQuestionDetail] = useState(""); // 質問詳細
  const [groupQuestion, setGroupQuestion] = useState(""); // 関連するQ&A
  const [keywordList, setKeywordList] = useState(""); // 注目のキーワード（取得）
  const [inputKeyword, setInputKeyword] = useState(""); // キーワード検索
  const [keywordMsg, setKeywordMsg] = useState(""); // 必須チェック用メッセージ(キーワード)
  const contents_question = []; // 質問内容
  const answer = []; // 回答
  const groups = []; // 関連するQ&A（質問内容）
  const keywords = []; // 注目のキーワード（表示）
  var group_que_number = 1;
  let body = { authKey: API.API_KEY };

  // useEffect初回読込フラグ
  const refIsFirst = useRef(true);

  // 初期表示
  useEffect(() => {
    // 初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    if (location.state.question !== -1) {                    //2023/04/26:プレビュー表示分岐のためif文とelseの中身を追加
      // 質問テーブル
      body.questionid = location.state.question;
      axios.post("/m_question/select/", body).then(res => {
        setQuestionDetail(res.data.questionList);
      });
    } else {
      let Detailt = [];
      Detailt[0] = previewdata.questionDetail;
      setQuestionDetail(Detailt);
    }

    // 関連するQ&A用
    body.groupid = location.state.group;
    axios.post("/m_question/select/qa/", body).then(res => {
      setGroupQuestion(res.data.groupList);
    });

    // よくあるご質問-注目のキーワードテーブル
    axios.post("/t_que_keyword/select/", body).then(res => {
      setKeywordList(res.data.keywordList);
    });

    // 初回読込フラグをfalseにセット
    refIsFirst.current = false;
  }, [location.state.question])

  // 質問詳細
  for (let i in questionDetail) {
    contents_question.push(<h1 className="q_h1">{questionDetail[i].contents_question}</h1>);

    // answer.push(<li><p><strong>A1</strong><br /><br />{questionDetail[i].question_answer}</p></li>);
    var naiyou = questionDetail[i].question_answer;
    var date = new Date(questionDetail[i].publish_date);            //2023/04/28:公開日を表示するため、update_dateから変更

    const options = { era: 'long', year: 'numeric', month: 'narrow', day: 'numeric' };
    var publish_date = new Intl.DateTimeFormat('ja-JP-u-ca-japanese', options).format(date);

    answer.push(<span className="update-month">{publish_date}にて作成</span>);
    answer.push(<h4 className="a_h4">回答</h4>);
    answer.push(parse(naiyou));
  }

  // 関連するQ&A
  for (let i in groupQuestion) {
    groups.push(<p className="D005_p" href="#" onClick={() => group_que(groupQuestion[i].question_id, groupQuestion[i].group_id)}><strong>Q{group_que_number}.</strong>&nbsp;&nbsp;{groupQuestion[i].contents_question}<ArrowForwardIosIcon /></p>);
    group_que_number = group_que_number + 1;
  }

  // 注目のキーワード
  for (let i in keywordList) {
    keywords.push(
      <Button
        // style={{ height: '24px', margin: '15px 0 0 25px' }}
        style={{
          borderRadius: "28px"
          , textDecoration: "none"
          , color: "#27335A"
          , padding: "5px 10px 5px 10px"
        }}
        sx={{ backgroundColor: "#EDEEF2" }}
        id={keywordList[i].search_kw_id}
        onClick={() => keyword_search(keywordList[i].keyword)}
      >
        {keywordList[i].keyword}
      </Button>
    );
  }

  // 関連するQ&A
  async function group_que(queId, groupId) {
    window.scroll({ top: 0, behavior: 'smooth' });
    return navigate("/D00502QuestionDetail", { state: { question: queId, group: groupId } })
  }

  // キーワード検索処理
  async function keyword_search(keyword) {
    console.log('キーワード検索開始');

    if (keyword == '' || keyword == null) {
      console.log('キーワード未入力エラー');
      setKeywordMsg("キーワードを入力して下さい。")
      return;
    }

    // グローバルIP取得
    let ip;
    try {
      await axios.get('https://ipinfo.io').then(res => ip = res.data.ip);
    } catch {
      ip = null;
    }

    return navigate("/D00503QuestionSearchList", { state: { search_keyword: keyword, ipaddr: ip } });
  }

  // アンケート登録
  async function questionnaire(useful_value) {
    console.log('アンケート結果保存開始');

    var csletr = [];
    var arrStr = [];

    // グローバルIP取得
    let ip;
    try {
      await axios.get('https://ipinfo.io').then(res => ip = res.data.ip);
    } catch {
      ip = null;
    }

    csletr.push(location.state.question);
    csletr.push(useful_value);
    csletr.push(ip);
    var arrStr = JSON.stringify(csletr);
    console.log(arrStr);

    body.arrStr = arrStr;

    const bbb = await axios.post("/t_que_useful/insert/", body);
    if (bbb.status === 200) {
      console.log('insert成功');
    } else {
      console.log('insert失敗');
    }

    console.log('アンケート結果保存終了');
    return alert("アンケートにご協力いただきまして、ありがとうございました。\nご回答は今後に活用させていただきます。");
  }

  return (
    <>
      <MenuMenu sel={0} />

      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">

              <Container maxWidth="lg" style={{ paddingLeft: "0", paddingRight: "0" }}>
                <Stack spacing={2}>

                  <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                  >
                    <Link underline="hover" key="1" color="inherit" href="./" style={{ fontSize: "14px" }}>
                      TOP
                    </Link>,
                    <Link underline="hover" key="2" color="inherit" href="./D00501QuestionList" style={{ fontSize: "14px" }}>
                      よくあるご質問
                    </Link>,
                    <Typography key="3" color="text.primary" style={{ fontSize: "14px" }}>
                      詳細
                    </Typography>
                  </Breadcrumbs>

                  {contents_question}
                  {answer}

                  {/* <div class="outline">
                    <p class="outline-heading">お問い合わせ先</p>
                    <div style={{margin: "0 12px"}}>
                      <p class="outline-heading_paragraph">輸出・国際局輸出支援課</p>
                      <div class="inquiry">
                        <div class="inquiry_line_SP"><span class="inquiry_tag">担当者</span><span>輸出相談窓口</span></div>
                        <div class="inquiry_line_SP"><span class="inquiry_tag">代表</span><span>03-3502-8111（内線4360）</span></div>
                      </div>
                      <div class="inquiry_line_PC" />
                      <div class="inquiry">
                        <div class="inquiry_line_SP"><span class="inquiry_tag">ダイヤルイン</span><span>03-6744-7185</span></div>
                        <div><span class="inquiry_tag">FAX番号</span><span>03-6738-6475</span></div>
                      </div>
                    </div>
                  </div> */}

                  {/* <div className="useful">
                    <h3>このページは役に立ちましたか？</h3>
                    <Button onClick={() => questionnaire(1)} className="search_button">はい</Button>
                    <span className="blank" />
                    <Button onClick={() => questionnaire(2)} className="search_button">いいえ</Button>
                  </div> */}

                  {/* <p className="question_title">関連するQ&A</p>
                  {groups}
                  <span className="blank" />

                  <div className="attention_word">
                    <Stack spacing={2} direction="row">
                      <TextField id="outlined-basic" variant="outlined" label="キーワードを入力" type='search'
                        error={Boolean(keywordMsg == "" ? false : true)}
                        helperText={keywordMsg}
                        value={inputKeyword}
                        onChange={e => { setInputKeyword(e.target.value) }}
                        sx={{ width: 950 }}
                      />
                      <Button style={{ width: '150px', height: '56px' }} onClick={() => keyword_search(inputKeyword)} className="search_button">検索</Button>
                    </Stack>

                    <Stack spacing={2} direction="row">
                      <p>注目のキーワード</p>
                      {keywords}
                    </Stack>
                  </div> */}

                  {/* <div className="center">
                    <Button href="./D00501QuestionList"
                      style={{
                        borderRadius: "28px"
                        , color: "white"
                        , textDecoration: "none"

                      }}                      
                      className="search_button">
                      一覧へ戻る
                    </Button>
                  </div> */}
                </Stack>
              </Container>

              <div className="other">
                <p><strong>その他ご不明点がありましたら、下記よりお問合せください。</strong></p>
                {/* <Button href="./D0041ContactTop"
                  style={{
                    borderRadius: "28px"
                    , textDecoration: "none"
                    , color: "white"
                  }}
                  sx={{ backgroundColor: "#B00002" }}
                  className="search_button">
                  お問合せフォームへ
                </Button> */}

                <div class="button">
                  <input
                    style={{
                      marginTop: "10px"
                      , width: "200px"
                      , fontSize: "16px"
                    }} type="button" onClick={() => window.location.href = "./D0041ContactTop"} class="buttonDefault" value="お問い合わせフォームへ" />
                </div>

                {/* <div class="btn"
                  style={{
                    marginTop: "10px"
                    , width: "200px"
                    , textAlign: "center"
                  }}>
                  <a href="./D0041ContactTop" class="buttonDefault">
                    お問い合わせフォームへ
                  </a>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default D00502QuestionDetail;